import { RootState } from '@reducers';

export const selectPersonalAccidentClaim = (state: RootState) =>
  state.userDashboardRouteReducer.claimDetails.personalAccidentClaimDetails;
